// import { create } from "zustand";
// import axios from "../lib/axios.js";

// const normalizeProduct = (product) => ({
//   ...product,
//   id: Number(product.id),
//   price: Number(product.price || 0),
//   available_quantity: Number(product.available_quantity || 0),
//   product_images:
//     product.product_images || product.images || [],
// });

// const normalizeProducts = (payload) => {
//   const products = payload?.products ?? payload;
//   return Array.isArray(products)
//     ? products.map(normalizeProduct)
//     : [];
// };

// const mergeLatestProducts = (collection, latestById) => {
//   if (!Array.isArray(collection)) {
//     return [];
//   }

//   return collection
//     .filter((product) => latestById.has(Number(product.id)))
//     .map((product) => ({
//       ...product,
//       ...latestById.get(Number(product.id)),
//     }));
// };

// export const useProductStore = create((set, get) => ({
//   products: [],
//   newProducts: [],
//   productsCategory: [],
//   trendingProducts: [],
//   recommendedProducts: [],
//   bridalProducts: [],
//   searchResults: [],
//   selectedProduct: null,
//   loading: false,
//   syncingInventory: false,
//   error: null,

//   setProducts: (products) => {
//     set({ products: normalizeProducts(products) });
//   },

//   getProducts: async () => {
//     set({ loading: true, error: null });

//     try {
//       const response = await axios.get("/products");
//       const products = normalizeProducts(response.data);
//       set({ products, loading: false });
//       return products;
//     } catch (error) {
//       set({
//         loading: false,
//         error:
//           error.response?.data?.message ||
//           "Unable to load products",
//       });
//       throw error;
//     }
//   },

//   getProductById: async (productId) => {
//     set({ loading: true, error: null });

//     try {
//       const response = await axios.get(`/products/${productId}`);
//       const product = normalizeProduct(
//         response.data?.product ?? response.data
//       );

//       set({ selectedProduct: product, loading: false });
//       return product;
//     } catch (error) {
//       set({
//         selectedProduct: null,
//         loading: false,
//         error:
//           error.response?.data?.message ||
//           "Unable to load product",
//       });
//       throw error;
//     }
//   },

//   getNewCollections: async () => {
//     set({ loading: true, error: null });

//     try {
//       const response = await axios.get("/products/new");
//       const products = normalizeProducts(response.data);

//       set({
//         newProducts: products,
//         productsCategory: products,
//         loading: false,
//       });

//       return products;
//     } catch (error) {
//       set({ newProducts: [], productsCategory: [], loading: false });
//       return [];
//     }
//   },

//   getTrendingProducts: async () => {
//     try {
//       const response = await axios.get("/products/trending");
//       const products = normalizeProducts(response.data);
//       set({ trendingProducts: products });
//       return products;
//     } catch (error) {
//       set({ trendingProducts: [] });
//       return [];
//     }
//   },

//   getRecommendedProducts: async () => {
//     try {
//       const response = await axios.get("/products/recommendations");
//       const products = normalizeProducts(response.data);
//       set({ recommendedProducts: products });
//       return products;
//     } catch (error) {
//       set({ recommendedProducts: [] });
//       return [];
//     }
//   },

//   getProductsByCategory: async (category) => {
//     set({ loading: true, error: null });

//     try {
//       const response = await axios.get(
//         `/products/category/${encodeURIComponent(category)}`
//       );
//       const products = normalizeProducts(response.data);
//       set({ productsCategory: products, loading: false });
//       return products;
//     } catch (error) {
//       set({ productsCategory: [], loading: false });
//       return [];
//     }
//   },

//   getBridalCollection: async () => {
//     try {
//       const response = await axios.get("/products/category/bridal");
//       const products = normalizeProducts(response.data);
//       set({ bridalProducts: products });
//       return products;
//     } catch (error) {
//       set({ bridalProducts: [] });
//       return [];
//     }
//   },

//   syncInventory: async () => {
//     if (get().syncingInventory) {
//       return get().products;
//     }

//     set({ syncingInventory: true });

//     try {
//       const response = await axios.get("/products");
//       const latestProducts = normalizeProducts(response.data);
//       const latestById = new Map(
//         latestProducts.map((product) => [Number(product.id), product])
//       );

//       set((state) => ({
//         products: latestProducts,
//         newProducts: mergeLatestProducts(state.newProducts, latestById),
//         productsCategory: mergeLatestProducts(
//           state.productsCategory,
//           latestById
//         ),
//         trendingProducts: mergeLatestProducts(
//           state.trendingProducts,
//           latestById
//         ),
//         recommendedProducts: mergeLatestProducts(
//           state.recommendedProducts,
//           latestById
//         ),
//         bridalProducts: mergeLatestProducts(
//           state.bridalProducts,
//           latestById
//         ),
//         searchResults: mergeLatestProducts(
//           state.searchResults,
//           latestById
//         ),
//         selectedProduct: state.selectedProduct
//           ? latestById.get(Number(state.selectedProduct.id)) || null
//           : null,
//         syncingInventory: false,
//       }));

//       return latestProducts;
//     } catch (error) {
//       console.error(
//         "Inventory synchronization failed:",
//         error.response?.data || error.message
//       );
//       set({ syncingInventory: false });
//       return get().products;
//     }
//   },

//   searchProducts: (query) => {
//     const normalizedQuery = String(query || "").trim().toLowerCase();

//     if (!normalizedQuery) {
//       set({ searchResults: [] });
//       return;
//     }

//     const state = get();
//     const uniqueProducts = new Map();

//     [
//       ...state.products,
//       ...state.newProducts,
//       ...state.productsCategory,
//       ...state.trendingProducts,
//       ...state.recommendedProducts,
//     ].forEach((product) => {
//       uniqueProducts.set(Number(product.id), product);
//     });

//     const searchResults = [...uniqueProducts.values()].filter(
//       (product) =>
//         product.name?.toLowerCase().includes(normalizedQuery) ||
//         product.description?.toLowerCase().includes(normalizedQuery)
//     );

//     set({ searchResults });
//   },
// }));

import { create } from "zustand";
import axios from "../lib/axios.js";

// ======================================
// Normalize one product
// ======================================
const normalizeProduct = (product) => ({
  ...product,
  id: Number(product.id),
  price: Number(product.price || 0),
  available_quantity: Number(
    product.available_quantity || 0
  ),
  product_images:
    product.product_images ||
    product.images ||
    [],
});

// ======================================
// Get product creation time
// ======================================
const getProductTime = (product) => {
  const productDate =
    product.createdAt ||
    product.created_at ||
    product.updatedAt ||
    product.updated_at;

  const timestamp = new Date(
    productDate || 0
  ).getTime();

  return Number.isFinite(timestamp)
    ? timestamp
    : 0;
};

// ======================================
// Sort newest products first
// ======================================
const sortNewestProductsFirst = (products) => {
  return [...products].sort(
    (firstProduct, secondProduct) => {
      const dateDifference =
        getProductTime(secondProduct) -
        getProductTime(firstProduct);

      if (dateDifference !== 0) {
        return dateDifference;
      }

      // Use the largest/newest ID when dates
      // are missing or identical.
      return (
        Number(secondProduct.id || 0) -
        Number(firstProduct.id || 0)
      );
    }
  );
};

// ======================================
// Normalize a product response
// ======================================
const normalizeProducts = (payload) => {
  const products =
    payload?.products ?? payload;

  if (!Array.isArray(products)) {
    return [];
  }

  return sortNewestProductsFirst(
    products.map(normalizeProduct)
  );
};

// ======================================
// Update existing collections with
// current stock and product information
// ======================================
const mergeLatestProducts = (
  collection,
  latestById
) => {
  if (!Array.isArray(collection)) {
    return [];
  }

  const mergedProducts = collection
    .filter((product) =>
      latestById.has(Number(product.id))
    )
    .map((product) => ({
      ...product,
      ...latestById.get(
        Number(product.id)
      ),
    }));

  return sortNewestProductsFirst(
    mergedProducts
  );
};

export const useProductStore = create(
  (set, get) => ({
    products: [],
    newProducts: [],
    productsCategory: [],
    trendingProducts: [],
    recommendedProducts: [],
    bridalProducts: [],
    searchResults: [],
    selectedProduct: null,
    loading: false,
    syncingInventory: false,
    error: null,

    // ======================================
    // Set all products
    // ======================================
    setProducts: (products) => {
      set({
        products:
          normalizeProducts(products),
      });
    },

    // ======================================
    // Get all products
    // ======================================
    getProducts: async () => {
      set({
        loading: true,
        error: null,
      });

      try {
        const response =
          await axios.get("/products");

        const products =
          normalizeProducts(response.data);

        set({
          products,
          loading: false,
        });

        return products;
      } catch (error) {
        set({
          loading: false,
          error:
            error.response?.data?.message ||
            "Unable to load products",
        });

        throw error;
      }
    },

    // ======================================
    // Get one product
    // ======================================
    getProductById: async (
      productId
    ) => {
      set({
        loading: true,
        error: null,
      });

      try {
        const response = await axios.get(
          `/products/${productId}`
        );

        const product = normalizeProduct(
          response.data?.product ??
            response.data
        );

        set({
          selectedProduct: product,
          loading: false,
        });

        return product;
      } catch (error) {
        set({
          selectedProduct: null,
          loading: false,
          error:
            error.response?.data?.message ||
            "Unable to load product",
        });

        throw error;
      }
    },

    // ======================================
    // Get New Arrival products
    // ======================================
    getNewCollections: async () => {
      set({
        loading: true,
        error: null,
      });

      try {
        const response =
          await axios.get("/products/new");

        const products =
          normalizeProducts(response.data);

        set({
          newProducts: products,
          productsCategory: products,
          loading: false,
        });

        return products;
      } catch (error) {
        console.error(
          "Unable to load new arrivals:",
          error.response?.data ||
            error.message
        );

        set({
          newProducts: [],
          productsCategory: [],
          loading: false,
          error:
            error.response?.data?.message ||
            "Unable to load new arrivals",
        });

        return [];
      }
    },

    // ======================================
    // Get trending products
    // ======================================
    getTrendingProducts: async () => {
      try {
        const response = await axios.get(
          "/products/trending"
        );

        const products =
          normalizeProducts(response.data);

        set({
          trendingProducts: products,
        });

        return products;
      } catch (error) {
        console.error(
          "Unable to load trending products:",
          error.response?.data ||
            error.message
        );

        set({
          trendingProducts: [],
        });

        return [];
      }
    },

    // ======================================
    // Get recommended products
    // ======================================
    getRecommendedProducts: async () => {
      try {
        const response = await axios.get(
          "/products/recommendations"
        );

        const products =
          normalizeProducts(response.data);

        set({
          recommendedProducts:
            products,
        });

        return products;
      } catch (error) {
        console.error(
          "Unable to load recommended products:",
          error.response?.data ||
            error.message
        );

        set({
          recommendedProducts: [],
        });

        return [];
      }
    },

    // ======================================
    // Get Dresses or Co-ords
    // ======================================
    getProductsByCategory: async (
      category
    ) => {
      set({
        loading: true,
        error: null,
      });

      try {
        const response = await axios.get(
          `/products/category/${encodeURIComponent(
            category
          )}`
        );

        const products =
          normalizeProducts(response.data);

        set({
          productsCategory: products,
          loading: false,
        });

        return products;
      } catch (error) {
        console.error(
          `Unable to load ${category}:`,
          error.response?.data ||
            error.message
        );

        set({
          productsCategory: [],
          loading: false,
          error:
            error.response?.data?.message ||
            `Unable to load ${category}`,
        });

        return [];
      }
    },

    // ======================================
    // Get bridal collection
    // ======================================
    getBridalCollection: async () => {
      try {
        const response = await axios.get(
          "/products/category/bridal"
        );

        const products =
          normalizeProducts(response.data);

        set({
          bridalProducts: products,
        });

        return products;
      } catch (error) {
        console.error(
          "Unable to load bridal collection:",
          error.response?.data ||
            error.message
        );

        set({
          bridalProducts: [],
        });

        return [];
      }
    },

    // ======================================
    // Refresh inventory information
    // ======================================
    syncInventory: async () => {
      if (get().syncingInventory) {
        return get().products;
      }

      set({
        syncingInventory: true,
      });

      try {
        const response =
          await axios.get("/products");

        const latestProducts =
          normalizeProducts(response.data);

        const latestById = new Map(
          latestProducts.map((product) => [
            Number(product.id),
            product,
          ])
        );

        set((state) => ({
          products: latestProducts,

          newProducts:
            mergeLatestProducts(
              state.newProducts,
              latestById
            ),

          productsCategory:
            mergeLatestProducts(
              state.productsCategory,
              latestById
            ),

          trendingProducts:
            mergeLatestProducts(
              state.trendingProducts,
              latestById
            ),

          recommendedProducts:
            mergeLatestProducts(
              state.recommendedProducts,
              latestById
            ),

          bridalProducts:
            mergeLatestProducts(
              state.bridalProducts,
              latestById
            ),

          searchResults:
            mergeLatestProducts(
              state.searchResults,
              latestById
            ),

          selectedProduct:
            state.selectedProduct
              ? latestById.get(
                  Number(
                    state.selectedProduct.id
                  )
                ) || null
              : null,

          syncingInventory: false,
        }));

        return latestProducts;
      } catch (error) {
        console.error(
          "Inventory synchronization failed:",
          error.response?.data ||
            error.message
        );

        set({
          syncingInventory: false,
        });

        return get().products;
      }
    },

    // ======================================
    // Search products
    // ======================================
    searchProducts: (query) => {
      const normalizedQuery = String(
        query || ""
      )
        .trim()
        .toLowerCase();

      if (!normalizedQuery) {
        set({
          searchResults: [],
        });

        return;
      }

      const state = get();
      const uniqueProducts = new Map();

      [
        ...state.products,
        ...state.newProducts,
        ...state.productsCategory,
        ...state.trendingProducts,
        ...state.recommendedProducts,
      ].forEach((product) => {
        uniqueProducts.set(
          Number(product.id),
          product
        );
      });

      const searchResults =
        sortNewestProductsFirst(
          [...uniqueProducts.values()].filter(
            (product) =>
              product.name
                ?.toLowerCase()
                .includes(
                  normalizedQuery
                ) ||
              product.description
                ?.toLowerCase()
                .includes(
                  normalizedQuery
                )
          )
        );

      set({
        searchResults,
      });
    },
  })
);